import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import "./assets/css/index.css";
import Kort from "./components/Kort.vue";
import List from "./components/liste/Liste.vue";

const routes = [
  { path: "/liste", component: List },
  { path: "/ny", component: Kort },
];

const router = new VueRouter({
  mode: "history",
  routes: routes,
});

Vue.use(VueRouter);
const app = new Vue({ router, render: (h) => h(App) });
app.$mount("#app");
